import React from 'react';
import './Search.css'

const SearchInput = ({ query, onQueryChange, showSuggestion, setShowSuggestion, checkDataLength }) => {
  return (
    <div className='search'
     onClick={()=>{
      setShowSuggestion(!showSuggestion);
      checkDataLength()
    }}
      >
        <input
            type="search"
            name="search"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Search"
            className="search-input"
            autoComplete='on'
        />
    </div>
    
  );
};

export default SearchInput;
